import P12 from "./P12";

export default P12;
